import { jsxs as n, jsx as s } from "react/jsx-runtime";
import { d as c, a7 as m } from "../../vendor-EQDp64ng.js";
import "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as a } from "../../utils/omitStyleRenderProps/index.js";
import '../../assets/index9.css';const _ = "_lg_vft8b_1", p = "_md_vft8b_6", b = "_sm_vft8b_11", i = "_progress_vft8b_16", l = "_bounceCenter_vft8b_1", r = {
  lg: _,
  md: p,
  sm: b,
  progress: i,
  bounceCenter: l
};
function x({ size: t = "md", ...e }) {
  const o = c(r.progress, r[t]);
  return /* @__PURE__ */ n(
    m,
    {
      ...a(e),
      isIndeterminate: !0,
      className: o,
      "aria-label": e["aria-label"],
      "data-component": "DotProgress",
      children: [
        /* @__PURE__ */ s("span", {}),
        /* @__PURE__ */ s("span", {}),
        /* @__PURE__ */ s("span", {})
      ]
    }
  );
}
export {
  x as DotProgress
};
